export const getRegistrations = instructorData => {
  if (!instructorData) return []
  if (Array.isArray(instructorData)) return instructorData
  if (typeof instructorData !== 'object') return []

  // The instructor/me payload can expose both `siteEducator` and `educator`
  // registration arrays. Include both so downstream completion/leaf-node lookups
  // can resolve a registration regardless of which bucket it lives in.
  return Object.values(instructorData).flatMap(scope => {
    if (!scope) return []
    if (Array.isArray(scope)) return scope
    if (typeof scope !== 'object') return []
    if (typeof scope.registration_id !== 'undefined') return [scope]

    return Object.values(scope).flatMap(value => {
      if (!value) return []
      if (Array.isArray(value)) return value
      if (
        typeof value === 'object' &&
        typeof value.registration_id !== 'undefined'
      ) {
        return [value]
      }
      return []
    })
  })
}

export const getRegistrationFromInstructorScope = (
  instructorData,
  scopeKey,
) => {
  const scope = instructorData?.[scopeKey]
  if (Array.isArray(scope) && scope.length > 0) {
    return scope[0]
  }
  if (scope && typeof scope === 'object' && scope.registration_id != null) {
    return scope
  }
  return null
}

export const matchesRegistrationCourseCode = (
  registration,
  normalizedCourseCode,
) => {
  if (!normalizedCourseCode) return false
  const registrationCourseCode = String(
    registration?.course_name || registration?.course_code || '',
  ).toLowerCase()
  return registrationCourseCode === normalizedCourseCode
}

export const findEducatorRegistrationByCourseCode = (
  instructorData,
  courseCode,
) => {
  const normalizedCourseCode = String(courseCode || '').toLowerCase()
  if (!normalizedCourseCode) return null

  const educatorRegistrations = Array.isArray(instructorData?.educator)
    ? instructorData.educator
    : []

  return (
    educatorRegistrations.find(registration =>
      matchesRegistrationCourseCode(registration, normalizedCourseCode),
    ) || null
  )
}
